// extracted by mini-css-extract-plugin
module.exports = {"articleBox":"page_articleBox__PsB_t"};